import { api } from './api';

/**
 * Typed client for the one-way CRM import (Salesforce + HubSpot).
 *
 * The actual sync work happens server-side in a BullMQ worker; both
 * endpoints return immediately. Callers should poll `runs()` to learn
 * the final counters once `status` flips to `succeeded` / `failed`.
 */
export interface CrmImportRun {
  id: string;
  installId: string;
  workspaceId: string;
  provider: string;
  status: 'pending' | 'running' | 'succeeded' | 'failed';
  accountsPulled: number;
  accountsCreated: number;
  accountsUpdated: number;
  contactsPulled: number;
  contactsCreated: number;
  contactsUpdated: number;
  error: string | null;
  startedAt: string;
  finishedAt: string | null;
}

export const crmImportApi = {
  async run(installId: string): Promise<{ runId: string; queued: boolean }> {
    const r = await api.post<{ runId: string; queued: boolean }>(
      '/api/crm-import/run',
      { installId },
    );
    return r.data;
  },

  async listRuns(installId: string, limit = 20): Promise<CrmImportRun[]> {
    const r = await api.get<CrmImportRun[]>('/api/crm-import/runs', {
      params: { installId, limit },
    });
    return r.data;
  },
};
